/*** 列表项(订单详情) **/
import './index.less';
import React from 'react';
import {Link} from 'react-router-dom';

function ListItem(props) {
  // console.log('props:', props);
  const {list, className} = props;

  const renLink = opt => {
    let {label, text, txtClass, txtType, url, index, target} = opt;
    if (target) {
      return (
        <li key={index}>
          <a href={url} className="item-content item-link">
            <div className="item-inner">
              <div className="item-title label">{label ? `${label}：` : null}</div>
              <div
                className={`${txtType && txtType === 'after' ? 'item-after' : 'item-input'} ${
                  txtClass ? txtClass : ''
                }`}
              >
                {text}
              </div>
            </div>
          </a>
        </li>
      );
    }
    return (
      <li key={index}>
        <Link to={url} className="item-content item-link">
          <div className="item-inner">
            <div className="item-title label">{label ? `${label}：` : null}</div>
            <div
              className={`${txtType && txtType === 'after' ? 'item-after' : 'item-input'} ${txtClass ? txtClass : ''}`}
            >
              {text}
            </div>
          </div>
        </Link>
      </li>
    );
  };
  const renItem = opt => {
    let {label, text, txtClass, txtType, index} = opt;
    return (
      <li key={index}>
        <div className="item-content">
          <div className="item-inner">
            <div className="item-title label">{label ? `${label}：` : null}</div>
            <div
              className={`${txtType && txtType === 'after' ? 'item-after' : 'item-input'} ${txtClass ? txtClass : ''}`}
            >
              {text}
            </div>
          </div>
        </div>
      </li>
    );
  };
  const renClick = opt => {
    let {label, text, txtClass, txtType, click, index} = opt;
    return (
      <li key={index}>
        <button
          className="button-link item-content item-link"
          data-label={label}
          data-text={text}
          onClick={typeof click === 'function' ? click : () => {}}
        >
          <div className="item-inner">
            <div className="item-title label">{label ? `${label}：` : null}</div>
            <div
              className={`${txtType && txtType === 'after' ? 'item-after' : 'item-input'} ${txtClass ? txtClass : ''}`}
            >
              {text}
            </div>
          </div>
        </button>
      </li>
    );
  };

  const renderList = list => {
    return list.map((item, index) => {
      const {label, text, txtClass, txtType, url, click, target} = item;
      let opt = {label, text, txtClass, txtType, index};
      if (url) {
        return renLink({...opt, url, target});
      } else if (click) {
        return renClick({...opt, click});
      } else {
        return renItem(opt);
      }
    });
  };
  return <ul className={`list-block list-item ${className ? className : ''}`}>{renderList(list)}</ul>;
}

export default ListItem;
